import React, { useState, useEffect } from 'react';
import {
    StyleSheet,
    Text,
    View,
    TextInput,
    TouchableOpacity,
} from 'react-native';
import {
    setStorage,
    getStorage,
} from '../storage';
import { Ionicons, FontAwesome } from '@expo/vector-icons';
import Data from './Data';

const CheckBox = ({ checked }: any) => {
    return (
        <View>
            {checked ?
                <Ionicons name="checkmark-circle-outline" size={17} color="white" />
                :
                <Ionicons name="ellipse-outline" size={17} color="white" />
            }
        </View>
    );
};

export default function Login({ navigation }: any) {
    const [checked, setChecked] = useState(false);
    const [data, setData] = useState({ id: '', pw: '' });
    const [hospitalName, setHospitalName] = useState('병원정보없음');

    useEffect(() => {
        const load = async () => {
            const getValue = await getStorage('AutoLogin');
            // 비밀번호가 들어 있어 콘솔에 남기지 않는다.
            if (getValue?.checked) {
                setData({ id: getValue?.id, pw: getValue?.pw });
                setChecked(getValue?.checked);
            }
        };
        load();
        getHospitalName();
        // const analysis = async () => {
        //     const RECENTsensorID = await getStorage('RECENTsensorID');
        //     navigation.navigate('SensorAnalysis', { sensorID: RECENTsensorID ? RECENTsensorID : 'F70CF24C9AC6' });
        // };
        // analysis();
        
    }, []);

    const getHospitalName = () => {
        Data.fetchData('user/selectHospitalAllInfo', {
        }, (result: any, count: any) => {
            // 응답 전체를 찍지 않는다(계정·토큰이 섞일 수 있다).
            if (count == 1) {
                setHospitalName(result[0]?.NAME);
            } 
        }, true);
    }

    const onChangeID = (text: any) => {
        setData({ id: text, pw: data?.pw })
    }
    const onChangePW = (text: any) => {
        setData({ id: data?.id, pw: text })
    }

    const onSignIn = () => {
        if (data?.id && data?.pw) {
            Data.fetchData('user/login', {
                ID: data?.id,
                PASSWORD: data?.pw
            }, (result: any, count: any) => {
                if (count == 1) {
                    const userInfo = result?.userInfo?.[0];
                    const admin = userInfo?.ADMIN;
                    const role = Number(userInfo?.ADMIN);
                    // 체크박스 값 최신 상태 사용
                    const autoLoginData = checked
                        ? { id: data?.id, pw: data?.pw, checked: true, admin: admin }
                        : { id: '', pw: '', checked: false, admin: admin };

                    setStorage('AutoLogin', autoLoginData);

                    const sessionData = {
                        id: userInfo?.ID,
                        role,
                        hospital: result?.hospitalInfo,
                        server: result?.serverVer,
                        // 중계기가 접속할 게이트웨이 공개 IP(서버 환경변수에서 옴).
                        // 포트는 화면이 빌드 때 주입된 값을 쓴다.
                        gwIp: result?.gwPublicIp || '',
                        token: result?.token,   // 서버가 발급한 접근 토큰
                    };
                    setStorage('Session', sessionData);

                    alert('로그인 되었습니다.');
                    // 뷰어는 Main 을 볼 권한이 없어 센서 화면으로 보낸다.
                    navigation.navigate(role === 2 ? 'SensorScreen' : 'Main', sessionData);
                } else {
                    alert('아이디 또는 비밀번호를 확인하세요');
                }
            }, true);
        } else {
            alert('아이디 또는 비밀번호를 입력하세요.');
        }
    };


    return (
        <View style={styles.container}>
            <Text style={styles.title}> 로그인 ({hospitalName})</Text>
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <FontAwesome name="user" size={30} color="white" style={{ marginRight: 15 }} />
                <TextInput autoCapitalize='none' clearButtonMode='always' placeholder={'아이디를 입력하세요.'}
                    style={styles.textInputBox} onChangeText={(text) => onChangeID(text)} value={data?.id} />
            </View>
            <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
                <FontAwesome name="lock" size={30} color="white" style={{ marginRight: 15 }} />
                <TextInput autoCapitalize='none' clearButtonMode='always' placeholder={'비밀번호를 입력하세요.'} secureTextEntry={true}
                    style={styles.textInputBox} onChangeText={(text) => onChangePW(text)} value={data?.pw} />
            </View>
            <View style={{ width: 400, flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', marginTop: 10 }}>
                <TouchableOpacity style={{ marginRight: 5 }} onPress={() => { setChecked(!checked) }}>
                    <CheckBox checked={checked} />
                </TouchableOpacity>
                <Text style={{ fontSize: 13, color: '#fff' }}>ID/PW 유지</Text>
            </View>
            <TouchableOpacity style={styles.buttonBox} onPress={() => { onSignIn() }}>
                <Text style={{ fontSize: 16, color: '#fff', fontWeight: '500' }}>SIGN IN</Text>
            </TouchableOpacity>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#304156',
    },
    title: {
        fontSize: 28,
        color: '#fff',
        marginBottom: 50
    },
    textInputBox: {
        width: 350,
        height: 50,
        borderWidth: 1,
        borderColor: '#fff',
        borderRadius: 10,
        paddingHorizontal: 13,
        color: '#fff'
    },
    buttonBox: {
        width: 400,
        height: 40,
        backgroundColor: '#42B983',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 10,
        marginTop: 10
    }

});